import script from "./aba-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./aba-button.vue?vue&type=script&setup=true&lang=ts"

import "./aba-button.vue?vue&type=style&index=0&id=8edacc04&lang=less"

const __exports__ = script;

export default __exports__